import styled from "@emotion/styled";

const Wrapper = styled.div`
  margin-bottom: 96px;
  overflow: hidden;
  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-bottom: ${({ theme }) => theme.space.space48};

    .swiper-slide {
      &:first-of-type {
        padding-left: 20px;
      }
    }
  }
`;

export { Wrapper };
